import React from 'react'
import { Link, useRouteError } from "react-router-dom";
import Page from '../components/layout/page.component';
import mainStyles from '../index.module.css'

export default function ErrorPage() {
  let error = useRouteError();
  console.error(error);

  return (
    <Page
      width='narrow'
      eyebrow='Erro 404'
      title='Ops!'
      subtitle='Página não encontrada!'>
      <div className={mainStyles.lines}>
        <Link to='/' className={mainStyles.button}>Voltar ao início</Link>
      </div>
    </Page>
  );
}
